import type { FC, RefAttributes } from "react";
import type { VariantProps } from "class-variance-authority";
import { buttonVariants } from "./variants/button-variants";
import { Link, type LinkProps } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import { cloneElement } from "react";

export interface NavLinkIconButtonProps
  extends LinkProps, VariantProps<typeof buttonVariants>, Partial<Pick<HTMLElement, "className">> {
  icon: React.ReactElement<HTMLElement>;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

export const NavLinkIconButton: FC<NavLinkIconButtonProps & RefAttributes<HTMLAnchorElement>> = ({
  ref,
  className,
  variant,
  size,
  icon,
  children,
  onClick,
  ...props
}) => {
  const iconMarginClass = children ? "mr-2" : "";

  const combinedClasses = cn(buttonVariants({ variant, size }), className);

  return (
    <Link
      className={combinedClasses}
      ref={ref}
      onClick={onClick}
      children={
        <>
          {cloneElement(icon, { className: cn("w-4 h-4", iconMarginClass, icon.props.className) })}
          {children}
        </>
      }
      {...props}
    />
  );
};

NavLinkIconButton.displayName = "NavLinkIconButton";
